import { createSlice } from "@reduxjs/toolkit";

const movieSlice = createSlice({
  name: "movies",
  initialState: {
    mainMovie: null,
    mainTrailer: null,
    nowPlayingMovies: [],
    popularMovies: [],
    topRatedMovies: [],
    upcomingMovies: [],
  },
  reducers: {
    addNowPlayingMovies(state, action) {
      state.nowPlayingMovies = action.payload;
    },
    removeMovies() {
      return {};
    },
    setMainMovie(state, action) {
      state.mainMovie = action.payload;
    },
    setMainTrailer(state, action) {
      state.mainTrailer = action.payload;
    },
    setPopularMovies(state, action) {
      state.popularMovies = action.payload;
    },
    setTopRatedMovies(state, action) {
      state.topRatedMovies = action.payload;
    },
    setUpcomingMovies(state, action) {
      state.upcomingMovies = action.payload;
    },
  },
});

export const {
  addNowPlayingMovies,
  removeMovies,
  setMainMovie,
  setMainTrailer,
  setPopularMovies,
  setTopRatedMovies,
  setUpcomingMovies,
} = movieSlice.actions;
export default movieSlice.reducer;
